<template>
  <div class="directoryes">
    <div class="information_header">
      <h1>Справочник анализаторов</h1>
    </div>
    <div class="directoryes_headline">
      <div class="directoryes_left">
        <button  @click="addItems" class="mb-2 btn">+ Добавить</button>
      </div>
      <div class="directoryes_right">
        <div class="directoryes_search">
          <label for="search_name">Поиск по названию</label>
          <input
            id="search_name"
            v-model="search"
            class="directoryes_search-input"
          />
          <svg class="svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6679 11.6679C12.0584 11.2774 12.6916 11.2774 13.0821 11.6679L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.6679 13.0821C11.2774 12.6916 11.2774 12.0584 11.6679 11.6679Z" fill="#4854FE"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.125 2C4.29454 2 2 4.29454 2 7.125C2 9.95546 4.29454 12.25 7.125 12.25C9.95546 12.25 12.25 9.95546 12.25 7.125C12.25 4.29454 9.95546 2 7.125 2ZM0 7.125C0 3.18997 3.18997 0 7.125 0C11.06 0 14.25 3.18997 14.25 7.125C14.25 11.06 11.06 14.25 7.125 14.25C3.18997 14.25 0 11.06 0 7.125Z" fill="#4854FE"/>
          </svg>
        </div>
      </div>
    </div>
      <v-data-table
          class="elevation-1"
          :headers="headers"
          :items="list"
          :loading="loadingTable"
          loading-text="Данные загружаются..."
          :page="page"
          sort-by="Name"
          :items-per-page="itemsPerPage"
          :search="search"
          hide-default-footer
      >
      <template v-slot:[`header.name`]="{ header }">
            <span style="font-size: 14px">{{ header.text}}</span>
        </template>
      <template v-slot:item="{item, index}">
        <tr @mouseover="changeIndex(index)" @mouseleave="indexHover = false" class="gray-bg">
          <td>{{ item.name }}</td>
          <td>
            <div v-if="indexHover === index" style="display: flex;">
                <button small @click="editeItems(item)" class="btn">Редактировать</button>
                <button small @click="deleteItems(item)" class="ml-2 btn-add" outlined color="indigo">Удалить</button>
            </div>
          </td>
        </tr>
      </template>
          <template v-slot:footer="{ props }">
              <div class="data-footer">
                  <div class="items-per-page">
                      <span>Строк на странице:</span>

                      <div class="items-per-page_item" :class="{active: itemsPerPage == 5}" @click.prevent="itemsPerPage = 5">
                          5
                      </div>
                      <div class="items-per-page_item" :class="{active: itemsPerPage == 10}" @click.prevent="itemsPerPage = 10">
                          10
                      </div>
                      <div class="items-per-page_item" :class="{active: itemsPerPage == 15}" @click.prevent="itemsPerPage = 15">
                          15
                      </div>
                      <div class="items-per-page_item" :class="{active: itemsPerPage == -1}" @click.prevent="itemsPerPage = -1">
                          все
                      </div>
                  </div>
                  <div class="pagination" v-if="itemsPerPage != -1">
                      <div class="pagination_prev" @click.prevent="page == 1 ? page : --page">
                          <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.81409 0.210823C4.94325 0.0744081 5.10763 -4.46523e-07 5.30137 -4.6346e-07C5.68884 -4.97335e-07 6 0.322435 6 0.731679C6 0.936302 5.91781 1.12232 5.78278 1.26494L1.67319 5.5062L5.78278 9.73506C5.91781 9.87768 6 10.0699 6 10.2683C6 10.6776 5.68885 11 5.30137 11C5.10763 11 4.94325 10.9256 4.81409 10.7892L0.246575 6.07666C0.0821913 5.91545 0.00587038 5.71702 -4.80825e-07 5.5C-4.99798e-07 5.28298 0.0821913 5.09696 0.246575 4.92954L4.81409 0.210823Z" fill="#94969C"/>
                          </svg>
                      </div>
                      <div class="pagination_number">
                          {{ props.pagination.pageStart + 1 }} - {{ props.pagination.pageStop }} из {{props.pagination.itemsLength}}
                      </div>
                      <div class="pagination_next" v-if="itemsPerPage" @click.prevent="page == props.pagination.pageCount ? page : ++page">
                          <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1.18591 0.210823C1.05675 0.0744081 0.892369 -4.46523e-07 0.698631 -4.6346e-07C0.311156 -4.97335e-07 9.33462e-07 0.322435 8.97685e-07 0.731679C8.79796e-07 0.936302 0.0821928 1.12232 0.217222 1.26494L4.32681 5.5062L0.217221 9.73506C0.082192 9.87768 8.13121e-08 10.0699 6.39655e-08 10.2683C2.81882e-08 10.6776 0.311155 11 0.69863 11C0.892368 11 1.05675 10.9256 1.18591 10.7892L5.75343 6.07666C5.91781 5.91545 5.99413 5.71702 6 5.5C6 5.28298 5.91781 5.09696 5.75343 4.92954L1.18591 0.210823Z" fill="#94969C"/>
                          </svg>
                      </div>
                  </div>
              </div>
          </template>

          <v-progress-linear :active="loadingTable" :indeterminate="loadingTable" absolute bottom color="primary accent-4" ></v-progress-linear>
      </v-data-table>

      <v-dialog v-model="dialog" max-width="600px" persistent>
        <div class="d-flex justify-end">
            <v-btn class="close" @click="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </v-btn>
        </div>
          <v-card max-width="570px">
                  <div style="width: 500px; padding: 20px 0 0 30px; display: flex; ">
                    <h2 class="header" style="width: 400px;">{{titleDialog}} анализаторов</h2>
                  </div>

              <v-card-text class="pb-0">
                  <v-container>
                      <v-form v-model="valid" ref="form" lazy-validation>
                          <v-row>
                              <v-col cols="12" sm="12" md="12">
                                  <h3 class="title-font">Наименование группы</h3>
                                  <v-text-field class="title-font" :rules="[rules.required]" dense outlined v-model="obj.name" />
                              </v-col>
                          </v-row>
                      </v-form>
                  </v-container>
              </v-card-text>

              <v-card-actions class="pb-5 mr-4 d-flex justify-end">
                <button  class="ma-2 btn-add" outlined color="indigo" @click="close">Отменить</button>
                  <button class="btn" :loading="saveLoading" @click="save(obj)">Сохранить</button>
              </v-card-actions>
          </v-card>
      </v-dialog>

      <v-snackbar rounded="pill" elevation="24" :color="snackbarColor" top v-model="snackbar">
          <div class="d-flex align-center">
              <img svg-inline :src="require('@/assets/img/icons/Information.svg')" />
              <span class="ml-4">{{ snackbar_text }}</span>
          </div>
      </v-snackbar>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import "../directory.scss";

export default {
  name: 'SprAnalyzer',
  computed: {
      ...mapGetters({
          apiGuide: 'apiGuide',
          apiUrl:'apiUrl'
      })
  },
  data: () => ({
      loadImport: false,
      saveLoading: false,
      edite: false,
      valid: false,
      snackbar: false,
      snackbar_text: '',
      snackbarColor: '',
      titleDialog: '',
      indexHover:null,
      loadingTable: false,
      dialog: false,
      sendingRequest: false,
      list: [],
      obj: {
          name: '',
      },
      headers: [
          { text: 'Наименование анализатора', value: 'name' },
          { text: '', value: 'actions', sortable: false, width: 250 }
      ],
      pagination: {
          sortBy: 'name'
      },
      page: 1,
      itemsPerPage: 10,
      search: '',
      rules: {
          required: (v, text) => !!v || (text ? text : 'Обязательно для заполнения.')
      }
  }),
  methods:{
      addItems() {
          this.titleDialog = 'Добавление'
          this.dialog = true
      },
      editeItems(item){
          this.edite = true;
          this.titleDialog = 'Редактирование'
          this.obj = Object.assign({}, item);
          this.dialog = true
      },
      changeIndex(index){
        this.indexHover = index
      },
      deleteItems(item){
          if(confirm('Вы уверены, что хотите удалить значение?')) {
              this.$http.delete(`${this.apiGuide}api/SprAnalyzer/MarkAsDelete?id=${item.id}`, {})
              .then(() => {
                  let index = this.list.findIndex((f) => f.id === item.id);
                  this.list.splice(index, 1);
              });
          }
      },
      save(obj) {
          if(this.$refs.form.validate()) {
              this.saveLoading = true;
              if(this.edite) {
                  this.$http.put(`${this.apiGuide}api/SprAnalyzer/Update`, {
                      id: obj.id,
                      name: obj.name,
                  })
                  .then((res) => {
                      for (let i = 0; i < this.list.length; i++) {
                          if(this.list[i].id === res.data.id) {
                              Object.assign(this.list[i], res.data);
                          }
                      }
                      this.close();
                  })
                  .catch((error) => {
                    if(error){
                        this.snackBarFunc(true, 'Запись с таким именем уже существует', 'warning')
                        }
                    })
              } else {
                  this.$http.post(`${this.apiGuide}api/SprAnalyzer/Add`, {
                      name: obj.name,
                  })
                  .then((res) => {
                      this.list.unshift(res.data);
                      this.close();
                  })
                  .catch((error) => {
                    if(error){
                        this.snackBarFunc(true, 'Запись с таким именем уже существует', 'warning')
                    }
                    })
              }
          } else {
              this.snackBarFunc(true, 'Заполните обязательные поля!!!', 'warning')
          }
      },
        snackBarFunc(flag, text, color) {
        this.snackbar = flag
        this.snackbar_text = text
        this.snackbarColor = color
    },
      close() {
          this.dialogImport = false;
          this.guideFile = null;
          this.$refs.form.resetValidation();
          this.edite = false;
          this.obj = { name: '' };
          this.saveLoading = false;
          this.dialog = false;
      },
      sortArray(array, name){
          return array.sort((prev, next) => {
              const nameA = typeof prev[name] === 'string' ? prev[name].toUpperCase() : prev[name];
              const nameB = typeof next[name] === 'string' ? next[name].toUpperCase() : next[name];

              if (nameA < nameB) return -1;
              if (nameA > nameB) return 1;
              return 0;
          })
      },
      get(){
          this.$http.get(`${this.apiGuide}api/SprAnalyzer/GetAll`)
          .then((res) => {
              this.list = this.sortArray(res.data, 'name');
              this.loadingTable = false;
          })
      }
  },
  created() {
     this.get();

  }
}
</script>
<style scoped>
.btn {
    padding: 6px 12px;
        border-radius: 8px;
        background: #4854FE;
        color: #FFF;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
  }
  .svg {
      position: absolute;
      top: 30px;
      right: 10px;
    }
    .btn-add {
        padding: 6px 12px;
        border-radius: 8px;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        white-space: nowrap;
        border: 2px solid #4854FE;
        color: #4854FE !important;
}
</style>
